'use client';

import { useEffect } from 'react';

import { captureUtmParameters } from '@ps/functions/campaign/utmAttribution';

/**
 * Captures the landing URL's `utm_*` params into the tab session. Renders
 * nothing.
 *
 * Mounted in the ROOT layout because campaign links land anywhere — a
 * storefront, a product page, a post — and the query string is gone by the time
 * the purchase completes on `/checkout/success`.
 *
 * Deliberately free of Firebase and rxjs: the root layout sits above the
 * Firebase-free `(bio)` tree, and nothing here may drag the SDK into the
 * visitor bundle.
 */
export function CaptureUtmAttribution() {
  useEffect(() => {
    captureUtmParameters();
  }, []);

  return null;
}
